<template>
  <div class="" id="pageTop" style="padding:1rem 1rem 10rem">
    <div class="">
      <div class="col-12">
        <div class="row">  
            <div class="col-12 col-lg-3"></div>  
            <div class="col-12 col-lg-6">
                <p align="right">
                    <button class="btn btn-link" @click="$router.back()"><i class="fas fa-arrow-left mr-2"></i> Return to registrations</button>
                </p>
                <ul class="list-group">
                    <li class="list-group-item">
                        <small>Date:</small>  <br/>{{String(userBookings[0].data.added.toDate()).slice(0,15)}}
                    </li>
                    <li class="list-group-item">
                        <small>Order Id:</small>  <br/>{{orderId}}
                    </li>
                    <li class="list-group-item">
                        <small>Name:</small>  <br/>{{userBookings[0].data.fname}} {{userBookings[0].data.lname}}, {{userBookings[0].data.club}}
                    </li>
                    <li class="list-group-item">
                        <strong>{{userBookings[0].data.confticket}}<br>
                        <em>{{userBookings[0].data.confeventname}}</em></strong>
                        <ul>
                            <li><small>Incoming Club Role:</small> <br/> {{userBookings[0].data.club_role}}</li>
                            <li><small>T-shirt:</small> <br/> {{userBookings[0].data.tshirt}}</li>
                            <li><small>Booklet:</small> <br/> {{userBookings[0].data.booklet}}</li>
                            <li><small>Dietary Requirements:</small> <br/> {{userBookings[0].data.dietsubject}} {{userBookings[0].data.dietdetails}}</li>
                            <li><small>Special Requirements:</small> <br/> {{userBookings[0].data.reqsubject}} {{userBookings[0].data.reqdetails}}</li>
                            <li>---</li>
                            <li><small><strong>Emergency Contact:</strong></small> <br/>{{userBookings[0].data.ename}}, {{userBookings[0].data.erelation}}, {{userBookings[0].data.ephone}}</li>
                            <li>---</li>
                        </ul>
                    </li>
                    <li class="list-group-item">
                        <strong>STATUS: {{ userBookings[0].data.status ? userBookings[0].data.status : 'PAID'}}</strong>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-lg-3"></div>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//const fb = require('../firebaseConfig')
export default {
  name: 'ViewRegistration',
  components: {
    
  },
  computed:{
    orderId(){
        return this.$route.params.orderId
    },
    userProfile(){
        return this.$store.state.userProfile
    },
    userBookings(){
        if(!Array.isArray(this.$store.state.userBookings)) return []
        if(Array.isArray(this.$store.state.userBookings) && this.$store.state.userBookings.length==1) return this.$store.state.userBookings
        
        const filter = (order)=>{
            return order.id==this.orderId
        }
        return this.$store.state.userBookings.filter(filter)
    }
  },
  data(){
    return{
      modalTitle:'',
    }
  },
  methods:{

  },
  mounted(){
    
  },
}
</script>
